/**
 * Copyright (c) 2015-present, Alibaba Group Holding Limited.
 * All rights reserved.
 *
 * @providesModule ReactNativeModules
 */
'use strict';

module.exports = {};


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/lib/NativeModules/NativeModules.winjs.js
 **/